import { defineStore } from "pinia";
import Services from '@/services/sutting/personTypesServices'
import { mapList, mapPersonType } from '@/helpers/mapFuncs'

export const usePersonTypesStore = defineStore("personTypes", {
persist: true,
state:()=>({
    personType: {},
    personTypes: [],
}),
getters : {
    getPersonType() {
        return mapPersonType(this.personType)
    },
    getPersonTypes() {
        return this.personTypes.map(mapPersonType)
    },
    getPersonTypesList() {
        return this.personTypes.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setPersonType(personType) {
        this.personType = personType
    },
    setPersonTypes(personTypes) {
        this.personTypes = personTypes
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setPersonType(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPersonTypes(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.personTypes.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.personTypes[this.personTypes.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.personTypes = this.personTypes.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
